import styled from '@emotion/styled';
import { themeGet } from '@styled-system/theme-get';

const getBackground = ({ theme: { color }, sectionTheme }) => {
  switch (sectionTheme) {
    case 'gradient':
      return `linear-gradient(172deg, ${color.colorWhite} 59.9%, transparent 60%), 
              linear-gradient(0deg, ${color.colorWhite} 0%, ${color.colorGrayBlue20} 60%)`;
    case 'tallGradient':
      return `linear-gradient(172deg, ${color.colorWhite} 45%, transparent 45%), 
              linear-gradient(0deg, ${color.colorWhite} 0%, ${color.colorGrayBlue20} 150%)`;
    case 'gray':
      return color.colorGrayBlue10;
    case 'white':
    default:
      return color.colorWhite;
  }
};

const getMobileGutters = ({ theme, gutters }) => {
  switch (gutters) {
    case 'narrow':
      return theme.scale.scaleDown03;
    case 'wide':
      return theme.scale.scaleUp05;
    default:
      return theme.scale.scaleBase;
  }
};

const getTabletGutters = ({ theme, gutters }) => {
  switch (gutters) {
    case 'narrow':
      return theme.scale.scaleUp05;
    case 'wide':
      return theme.scale.scaleUp09;
    default:
      return theme.scale.scaleUp03;
  }
};

/**
 *
 * Use margins instead of padding for white themes so that
 * white + white sections appear collapsed
 */
const getVerticalSpace = ({ theme: { breakpoint, scale }, sectionTheme }) => {
  const property = sectionTheme === 'white' || sectionTheme === 'tallGradient' ? 'margin' : 'padding';
  return `
    ${property}: ${scale.scaleUp09} 0;
    @media (min-width: ${breakpoint.breakpointMobile}) {
      ${property}: ${scale.scaleUp12} 0;
    }

    @media (min-width: ${breakpoint.breakpointTablet}) {
      ${property}: 140px 0;
    }
  `;
};

export const StyledRow = styled.div`
  max-width: 1030px;
  margin: 0 auto;
  padding: 0 ${getMobileGutters};

  @media (min-width: ${themeGet('breakpoint.breakpointMobile')}) {
    padding: 0 ${getTabletGutters};
  }

  @media (min-width: ${themeGet('breakpoint.breakpointTablet')}) {
    padding: 0 ${themeGet('scale.scaleUp05')};
  }
`;

export const StyledSection = styled.article`
  background: ${getBackground};
  ${getVerticalSpace}
`;
